import axios from 'axios';
import { TokenData, BinInformation, InstallmentPlanInformation } from 'src/interfaces';

export const tokenize = async (apiKey: string, data: TokenData) => {
    const response = await axios.post(`${CVAULT_URL}/credit-card/temporal`, data, {
        headers: {
            ['x-fields-api-key']: apiKey,
            ['x-client']: 'DLOCAL-DIRECT'
        }
    });
    return response;
};

export const getBinInformation = async (apiKey: string, bin: string, country: string): Promise<BinInformation> => {
    const { data } = await axios.post(`${SERVER_URL}/bin`, { bin, country }, { headers: { ['x-fields-api-key']: apiKey } });
    return data;
};

export const getInstallmentsPlan = async (apiKey: string, amount: number, currency: string, country: string, bin: string): Promise<InstallmentPlanInformation> => {
    const { data } = await axios.post(`${SERVER_URL}/installments`, { amount, currency, country, bin }, { headers: { ['x-fields-api-key']: apiKey } });
    return data;
};

export async function logToServer(apiKey: string, message, level = 'info', metadata = {}) {
    await axios.post(`${SERVER_URL}/log`, { message, level, metadata }, { headers: { ['x-fields-api-key']: apiKey } });
}
